import { Box, Button, Card, Grid, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { Controller, useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { CustomerService } from '../Service';
import { LocalStore } from '../../../storage/authStore';
import WalletTransactions from './WalletTransactions';
import { PermissionGuard } from '../../../components/PermissionGuard';

const WalletDetails = ({walletData,fetchData}) => {
    const {id} = useParams();
    const loggedUser = LocalStore.getLoggedUserDetails();
    const [addCudelCoins,setAddCudelCoins] = useState(false);
    const [refreshTransactionList,setRefreshTransactionList] = useState(false);

    const {control,watch,setValue,handleSubmit,reset} = useForm({
        mode:'onChange',
        defaultValues: {
            customerId: id,
            coins: '',
            message: '0 Cudel Coins Added',
        },
    });
    const coins = watch('coins');
    useEffect(() => {
        if (coins>0) {
            setValue('message',`${coins} Cudel Coins Added`);
        }else{
            setValue('message','0 Cudel Coins Added');
        }
    }, [coins]);
    const onSubmit = async(data)=>{
        console.log("data",data);
        const modifiedData = {
            customerId: parseInt(id),// as number
            coins: parseInt(data.coins),// as number
            message: data.message,
        }
        // on submit show processing usinf swal and then call the api
        // if success then show success message
        // if error then show error message
        // if error then show error message
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'Do you want to add Cudel Coins?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Add now!',
            cancelButtonText: 'No, Cancel',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showCloseButton: false,
        });
        if(result.isConfirmed){
            try {
                // Show loading state
                Swal.fire({
                    title: 'Please wait...',
                    html: 'Adding Cudel Coins',
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });
                const submitResponse = await CustomerService.addCudelCoins(modifiedData);
                console.log("submitResponse",submitResponse);
                if (submitResponse.success == '1') {
                    Swal.fire({
                        title: 'Success',
                        text: `${coins} Cudel Coins added successfully`,
                        icon: 'success',
                        timer: 1500
                    });
                    fetchData();
                    setRefreshTransactionList(true);
                    setAddCudelCoins(false);
                    reset();
                    return true;
                }else{
                    console.log("submitResponse",submitResponse);
                    Swal.fire({
                        title: 'Error',
                        text: submitResponse.message || 'Failed to add Cudel Coins',
                        icon: 'error',
                    });
                }
            } catch (error) {
                console.error('Error updating SAC code:', error);
                Swal.fire({
                    title: 'Error',
                    text: 'Failed to update SAC code',
                    icon: 'error',
                });
            }
        }

    }
  return (
    <Box>
        <Card sx={{mb:'1%'}}>
          <Box sx={{p:'.5% 1%',border:'2px solid lightGray',bgcolor:'lightGray'}}>
              <Typography sx={{fontWeight:'600',fontSize:'0.85rem'}}>Wallet Detail's</Typography>
          </Box> 
          
            <Box sx={{p:'1%',display:'flex',justifyContent:'space-between'}}>
                <Box sx={{display:'flex',gap:1}}>
                    <Typography sx={{fontWeight:600,fontSize:'0.75rem',textAlign:'center'}}>Available Cudel Coins : </Typography>
                    <Typography sx={{fontWeight:600,fontSize:'0.75rem',textAlign:'center'}}>{walletData?.totalCoins}</Typography>
                    {/* <Typography sx={{fontWeight:600,fontSize:'0.75rem',textAlign:'center',width:'100%'}}>Cudel Coins </Typography> */}
                </Box>
                {/* {(loggedUser?.role.title == 'Super Admin') && */}
                <PermissionGuard feature='wallet-management' permission='canView'>
                    <Box>
                        <Button size='small' variant="contained" color="primary" sx={{width:'100%',fontSize:'0.75rem',fontWeight:600,textTransform:"capitalize"}} onClick={()=>setAddCudelCoins(true)}>Add Cudel Coins</Button>
                    </Box>
                </PermissionGuard>
                {/* } */}
            </Box>
            { addCudelCoins &&
            
                <Box component={'form'} sx={{p:'1%'}} onSubmit={handleSubmit(onSubmit)}>
                    <Grid container spacing={2} sx={{pt:'0%!important'}}>
                        <Grid item xs={12} sm={4}>
                            <Box sx={{p:'1%'}}>
                                <Typography sx={{fontWeight:'600', texttTransform:'uppercase', display:'flex ',alignItems:'center',fontSize:'0.75rem'}}>Enter Coin Amount<span style={{color:'#d32f2f'}}>*</span></Typography>
                                <Controller
                                    control={control}
                                    name="coins"
                                    rules={{
                                        required:'enter Coin Amount',
                                        validate: (value) => {
                                        const numValue = parseInt(value, 10);                  
                                        if (isNaN(numValue)) return 'Please enter a valid Amount';
                                        if (numValue <= 0) return 'Coin Amount should be greater than 0';
                                        return true;                    
                                        }
                                    }}
                                    render={({field,fieldState:{error}})=>(
                                        <TextField
                                            {...field}
                                            size='small'
                                            error={!!error}
                                            type='number'
                                            placeholder='0'
                                            fullWidth
                                            // Add these props to prevent increment/decrement
                                            inputProps={{
                                                style: { fontSize: '0.65rem' },
                                                onWheel: (e) => e.target.blur(),  // Prevent scroll wheel
                                                onKeyDown: (e) => {
                                                    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                                        e.preventDefault();
                                                    }
                                                }
                                            }}
                                            onChange={(e) => {
                                                const inputValue = e.target.value;
                                                if (inputValue === '' || /^\d*\.?\d*$/.test(inputValue)) {
                                                // field.onChange(formatValue(inputValue));
                                                let finalValue = formatValue(inputValue);
                                            
                                                // Check if the value exceeds 10000 and constrain it
                                                const numValue = parseInt(finalValue);
                                                if (!isNaN(numValue) && numValue > 999) {
                                                    finalValue = '999';
                                                }
                                                
                                                field.onChange(finalValue);
                                                }
                                            }}
                                        />
                                    )}
                                />
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={8}>
                            <Box sx={{p:'1%'}}>
                                <Typography sx={{fontWeight:'600', texttTransform:'uppercase', display:'flex ',alignItems:'center',fontSize:'0.75rem'}}>Comment<span style={{color:'#d32f2f'}}>*</span></Typography>
                                <Controller
                                    control={control}
                                    name="message"
                                    rules={{
                                        required:'Enter Comment',
                                        validate: (value) => {
                                            if (value.trim().length === 0) return 'Comment is required';
                                            return true;
                                        }
                                    }}
                                    render={({field,fieldState:{error}})=>(
                                        <TextField
                                            {...field}
                                            size='small'
                                            inputProps={{style:{fontSize:'0.65rem'}}}
                                            fullWidth
                                            error={error}
                                        />
                                    )}
                                />
                            </Box>
                        </Grid>
                        <Grid item xs={12}></Grid>
                            <Box sx={{display:'flex',justifyContent:'center',gap:2,alignItems:'center',width:'100%',p:'1%'}}>
                                <Button sx={{textTransform:'capitalize'}} variant='contained' color='primary' size='small' type='submit'>Submit</Button>
                                <Button sx={{textTransform:'capitalize'}} variant='contained' color='error' size='small' onClick={()=>setAddCudelCoins(false)}>Cancel</Button>
                            </Box>
                    </Grid>
                </Box>
                
            }
        </Card>
        <WalletTransactions refreshTransactionList = {refreshTransactionList} setRefreshTransactionList={setRefreshTransactionList}/>
    </Box>
  );
}

export default WalletDetails;
const formatValue = (value) => {
    if (!value) return '';  // Return empty string instead of 0
    const numValue = parseFloat(value);
    return isNaN(numValue) ? '' : numValue.toString();
  }